import { Col, FormCheck, ListGroupItem, Row } from "react-bootstrap";
import { FaCheck, FaSwimmingPool } from "react-icons/fa";
import { FaFileCircleExclamation, FaFileCircleXmark } from "react-icons/fa6";
import { HiXMark } from "react-icons/hi2";
import { TbCoins, TbTruckDelivery, TbFileUnknown } from "react-icons/tb";
import CommonUtils from "../../utils/common";

const DownloadInvoiceListItem = ({invoice, singleCheckHandler, type}) => {

    const UTIL = new CommonUtils();

    return (
        <ListGroupItem
            key={`${type}:${invoice.id}`}
        >

                <Row style={invoice.x_datum_download !== "False"? {opacity: 0.3}: null}>
                    <Col xs="10" xl="1">
                        <FormCheck 
                            type="checkbox" 
                            onChange={e => singleCheckHandler(e, type, invoice.id)}
                            id={`${type}:${invoice.id}`}    
                        />
                    </Col>
                    <Col xl="1" >
                        {
                            type === "poolrechnung"? <FaSwimmingPool className="text-energo rounded" size={30} /> :
                            type === "abrechnung"? <TbTruckDelivery className="text-primary" size={30} /> :
                            type === "vorschreibung"? <TbCoins className="text-warning" size={30} /> :
                            <TbFileUnknown className="text-muted" />
                        }
                    </Col>
                    <Col xs="12" xl="3">
                        {
                            type === "poolrechnung"? `${invoice.x_rechnungsart} ENERGO` :
                            type === "abrechnung"?  invoice.x_is_final_invoice? "Endrechnung Energie" : "Abrechnung Energie" :
                            type === "vorschreibung"? "Vorschreibung" :
                            null
                        }
                    </Col>
                    <Col xl="3">
                        {invoice.x_kunde_id && invoice.x_kunde_id[1]}
                    </Col>
                    <Col xs="6" xl="2">
                        <span className="text muted">{UTIL.dateToEuFormat(invoice.create_date)}</span>
                    </Col>
                    <Col xl="2" className="text-center">
                            {invoice.x_datum_download !== "False"?
                                <FaCheck size={20} className="text-energo" /> :
                                <HiXMark size={20} className="text-danger" />
                            }
                    </Col>
                </Row>

            {invoice.x_file_abrechnung2_name && invoice.x_file_abrechnung2_name !== "False" && invoice.x_datum_download === "False" &&
                <Row className="mt-2">
                    <Col xs="10" xl="1">
                        
                    </Col>
                    <Col xl="2">
                        <TbTruckDelivery className="text-primary" size={30} />
                    </Col>
                    <Col xs="12" xl="5">
                        Abrechnung Teil 2
                    </Col>
                    <Col xs="6" xl="2">
                        <span className="text muted">{UTIL.dateToEuFormat(invoice.create_date)}</span>
                    </Col>
                    <Col xl="2" className="text-center">
                        <HiXMark size={20} className="text-danger" />
                    </Col>
                </Row>
            }

            {invoice.x_file_mahnung_name && invoice.x_file_mahnung_name !== "False" && invoice.x_datum_download_mahnung === "False" &&
                <Row className="mt-2">
                    <Col xs="10" xl="1">
                        
                    </Col>
                    <Col xl="2">
                        <FaFileCircleExclamation className="text-warning" size={30} />
                    </Col>
                    <Col xs="12" xl="5">
                        Mahnung
                    </Col>
                    <Col xs="6" xl="2">
                        <span className="text muted">{UTIL.dateToEuFormat(invoice.create_date)}</span>
                    </Col>
                    <Col xl="2" className="text-center">
                        <HiXMark size={20} className="text-danger" />
                    </Col>
                </Row>
            }
            {invoice.x_file_stornorechnung_name !== undefined && invoice.x_file_stornorechnung_name !== "False" && invoice.x_datum_download_storno === "False" &&
                <Row className="mt-2">
                    <Col xs="10" xl="1">
                       
                    </Col>
                    <Col xl="2">
                        <FaFileCircleXmark className="text-danger" size={30} />
                    </Col>
                    <Col xs="12" xl="5">
                        Stornorechnung
                    </Col>
                    <Col xs="6" xl="2">
                        <span className="text muted">{UTIL.dateToEuFormat(invoice.create_date)}</span>
                    </Col>
                    <Col xl="2" className="text-center">
                        <HiXMark size={20} className="text-danger" />
                    </Col>
                </Row>
            }
        </ListGroupItem>
    )
}
export default DownloadInvoiceListItem;